import { Box } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import {
  FormTitleBox,
  ConfirmationDialog,
} from '../../common/components';
import InventoryArticlesFilters from './components/InventoryArticlesFilters';
import InventoryArticlesDataTable from './components/InventoryArticlesDataTable';
import InventoryArticlesPagination from './components/InventoryArticlesPagination';
import InventoryArticleDialog from './components/InventoryArticleDialog';
import { useInventoryArticlesTable } from './hooks/useInventoryArticlesTable';
import { useUnits } from '../../hooks/useUnits';

const InventoryArticles = () => {
  const { data: units = [] } = useUnits();
  const {
    data,
    isLoading,
    totalPages,
    totalCount,
    page,
    rowsPerPage,
    searchTerm,
    filters,
    dialogOpen,
    editMode,
    selectedArticle,
    deleteDialogOpen,
    articleToDelete,
    mutationsLoading,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
    handleFilterChange,
    handleOpenDialog,
    handleCloseDialog,
    handleEdit,
    handleCreate,
    handleUpdate,
    handleDeleteRequest,
    handleConfirmDelete,
    handleCancelDelete,
  } = useInventoryArticlesTable();

  return (
    <Box>
      <FormTitleBox
        title="Stock y compras | Inventario de artículos"
        showButton
        buttonText="Nuevo artículo"
        buttonIcon={AddIcon}
        onButtonClick={handleOpenDialog}
      />

      <InventoryArticlesFilters
        filters={filters}
        onFilterChange={handleFilterChange}
        searchTerm={searchTerm}
        onSearchChange={handleSearch}
      />

      <InventoryArticlesDataTable
        data={data}
        units={units}
        isLoading={isLoading}
        onEdit={handleEdit}
        onDelete={handleDeleteRequest}
      />

      {totalPages > 1 && (
        <InventoryArticlesPagination
          totalPages={totalPages}
          totalCount={totalCount}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      )}

      <InventoryArticleDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        editMode={editMode}
        selectedArticle={selectedArticle}
        onCreate={handleCreate}
        onUpdate={handleUpdate}
        isSubmitting={mutationsLoading}
      />

      <ConfirmationDialog
        open={deleteDialogOpen}
        onClose={handleCancelDelete}
        onConfirm={handleConfirmDelete}
        entityName="artículo"
        message={
          articleToDelete
            ? `¿Confirmás eliminar el artículo "${articleToDelete.code} - ${articleToDelete.name}"?`
            : '¿Confirmás eliminar el artículo seleccionado?'
        }
      />
    </Box>
  );
};

export default InventoryArticles;
